import { useEffect, useRef } from 'react';

import { observeLastSiblingBackground } from './observeLastSiblingBackground';

/**
 * Returns a ref to attach to the notch spacer element.
 *
 * Sets the element's inline `backgroundColor` to match the computed
 * background of the last preceding sibling, keeping it in sync whenever
 * the parent's children change.
 *
 * @returns {React.RefObject<HTMLElement>}
 */
export const useNotchSpacerBackground = () => {
  const spacerRef = useRef(null);

  useEffect(() => {
    const spacer = spacerRef.current;

    if (!spacer) {
      return undefined;
    }

    const unobserve = observeLastSiblingBackground(spacer, colour => {
      spacer.style.backgroundColor = colour ?? '';
    });

    return unobserve;
  }, []);

  return spacerRef;
};
